import { Box, Container, DialogContent, Step, StepLabel, Stepper, Typography } from "@mui/material"
import { useFormContext } from "react-hook-form";
import { useState } from "react";
import Step01 from "./Step01";
import Step02 from "./Step02";

export default function StepperApGlobal() {
    const { watch, setValue} = useFormContext()

    const activeStep = watch('stepper')

    const [selected, setSelected] = useState<readonly string[]>([]);

    //Funções manipuladoras
    const handleChangeSelected = (value: readonly string[]) => {
        setSelected(value)
        setValue('selecionar_titulos', value)
    }
    //

    //valores importantes
    const steps = [
        {
            label: 'Selecionar títulos',
            content: <Step01 {...{ handleChangeSelected, selected }} />
        },
        {
            label: 'Dados dos títulos',	
            content: <Step02 />
        },
    ]
    //
    return (
        <>
                <DialogContent>
                    <Stepper activeStep={activeStep}>
                        {steps.map((step, index) => (
                            <Step key={step.label}>
                                <StepLabel>
                                    <Typography fontWeight={activeStep === index ? 'bold' : ''} variant="subtitle1">{step.label}</Typography>
                                </StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                    <Container>

                    <Box sx={{ mt: 2 }}>
                        {steps.map((step, index) => (
                            <Box key={index} sx={{ display: activeStep === index ? 'block' : 'none' }}>
                                {step.content}
                            </Box>
                        ))}
                    </Box>

                    </Container>

                </DialogContent>
        </>
    )
}
